import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, ViewChildren } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { UnsubscribeOnDestroy } from '../../../../utility'
import { debounceTime, tap } from 'rxjs/operators'

@Component({
    selector: 'app-search-ai',
    templateUrl: 'search-ai.html',
})
export class SearchAiComponent extends UnsubscribeOnDestroy implements AfterViewInit {
    @Input() inline = false
    @Input() collapsableSearchInput = true
    @Input() columnLayout = false
    @Input() placeholderText = "Describe your perfect stay... (e.g. 'Beach villa in Bali with infinity pool, suitable for family of 4')"
    @Input() inputModifierClasses: string
    @Input() initWithValue: string

    loading = false
    searchTerm = ''
    isActive = false
    showSearchInput = false
    formGroup: FormGroup

    @Output() onSearchInput = new EventEmitter<string>()
    @Output() onSearchActivated = new EventEmitter<boolean>()

    @ViewChildren('aiSearchTextInput') aiSearchTextInput: QueryList<ElementRef>

    @HostListener('document:keydown.escape', ['$event'])
    handleKeyboardEvent() {
        this.closeSearchInput()
    }

    @HostListener('document:click', ['$event'])
    clickout(event: Event) {
        const targetElement = event.target as HTMLInputElement

        if (!this.eRef.nativeElement.contains(targetElement) && !this.searchTerm && this.showSearchInput) {
            this.closeSearchInput()
        }
    }

    constructor(
        private eRef: ElementRef<HTMLElement>
    ) {
        super()

        this.formGroup = new FormGroup({
            aiSearchTextValue: new FormControl()
        })

        this.formGroup.get('aiSearchTextValue')?.valueChanges
            .pipe(
                tap(() => {
                    this.isActive = false
                }),
                debounceTime(1000)
            )
            .subscribe(value => {
                this.isActive = !!value
                this.searchTerm = value
                this.onSearchInput.emit(value)
        })
    }

    ngAfterViewInit(): void {
        this.aiSearchTextInput.changes.subscribe(() => {
            const input = this.aiSearchTextInput?.first

            if (input?.nativeElement) {
                input.nativeElement.focus()
            }
        })

        if (this.initWithValue) {
            this.searchTerm = this.initWithValue
            this.formGroup.controls.aiSearchTextValue.setValue(this.initWithValue)
            this.activateSearchInput()
        }
    }

    activateSearchInput() {
        this.showSearchInput = true
        this.onSearchActivated.emit(true)
    }

    closeSearchInput() {
        this.formGroup.controls.aiSearchTextValue.setValue('')
        this.searchTerm = ''
        this.showSearchInput = false
        this.onSearchActivated.emit(false) 
    }
}
    